module.exports = __webpack_public_path__ + "static/media/logo-red.195dd46f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-red.svg
// module id = 636
// module chunks = 0